interface Review {
  flag?: string;
  heading: string;
  name: string;
  rating: number;
  review: string;
}

const reviewRowOne: Review[] = [
  {
    heading: 'The variety is what really hooks me',
    review:
      "The variety is what really hooks me. it's definitely worth the money. I'm able to use a long range of classical music, to 8 bit to heart warming melody.",
    name: 'Romanss',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Truly one of the best',
    review:
      'So far the music is great and truly one of the best selections of royalty free music out there. Uppbeat is the sound for my new Channel.',
    name: 'Dana Foreman',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Makes my videos 100% better',
    review:
      "It's very easy to use. Great choices of music and sound effects. Uppbeat makes my videos 100% better.",
    name: 'Mark Snead',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'A music and SFX paradise',
    review:
      'I just keep coming back more and more often. Why? Because there is always something new to explore. For me as a video creator Uppbeat is a music and sounds effects paradise.',
    name: 'Alex Laszlo',
    rating: 5,
    flag: '🇨🇦',
  },
  {
    heading: 'The best creator music platform under the sun',
    review:
      'Not only the website is clean, polished and tuned to perfection, the music itself is great and covers any need! ',
    name: 'Ledom Software',
    rating: 5,
    flag: '🇨🇱',
  },
  {
    heading: "I couldn't create without Uppbeat",
    review:
      "I couldn't create without Uppbeat. The best part? They have really cool music, not lame stuff you can get on other platforms! Love!",
    name: 'Shannon',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: "It's our go-to resource ",
    review:
      "The Wanderer Family USA loves Uppbeat! Uppbeat Premium is very affordable, and there's a nice selection of songs, all with no worries of copyright claims. It's our go-to resource for all our videos.",
    name: 'The Wanderer Family USA',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Saved Me from YouTube Copyright Strikes',
    review:
      'its been almost a year using Uppbeat and I cannot be more satisfied as the quality and quantity of the Music they provide are so top notch and keep on adding new tracks every time.',
    name: 'Abhishek Nath',
    rating: 5,
    flag: '🇮🇳',
  },
];

const reviewRowTwo: Review[] = [
  {
    heading: 'Perfect tool',
    review:
      "A lot of songs are for free so that's amazing for anyone, and for pros like me the Premium is so worth it! I use it on every project now and with the addition of sound effects, this is a no-brainer. ",
    name: 'Jo',
    rating: 5,
    flag: '🇫🇷',
  },
  {
    heading: 'Great Selection, Easy Navigation, Awesome!',
    review:
      'I love this music site! Not only is it easy to navigate the site, but finding the perfect track to complement my project is super simple and the selection is massive! After downloading the tracks I need, I sit back and enjoy random tracks, just for cool music to listen to.',
    name: 'GoldOwlGaming',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Amazing Music Library',
    review:
      'I love the selection of music available. I use their music in my youtube videos and always find the perfect songs to get the right mood for what I want my audience to experience. I totally recommend it!',
    name: 'Gerd Schweinitz',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Truly a game-changer',
    review:
      'Truly a game-changer and disrupter in the world of music licensing. Gives more power to ordinary creators and content makers!',
    name: 'Ronald James Baculo',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Music to match our creativity',
    review:
      'We can now immerse our listeners and watchers with captivating music to match our creativity. ',
    name: 'John Hilla',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Nothing Similar Comes Close',
    review:
      "Brilliant platform, wide variety of stuff to use. I've used a couple of sites for the same thing and nothing comes close, bargain as well.",
    name: 'Sam',
    rating: 5,
    flag: '🇬🇧',
  },
  {
    heading: 'Awesome',
    review:
      "Awesome, easy and vibrant. Upbeat is so far the best music platform I've ever found to use for my youtube background music.",
    name: 'Keep Thinking',
    rating: 5,
    flag: '🇮🇶',
  },
  {
    heading: "A YouTuber's best friend",
    review:
      "Uppbeat has become one of my go-to sources for music for my videos. I especially like how they've built categories that are relevant to video creators. Plus they have a fantastic sound effects library!",
    name: 'Mark Draper',
    rating: 5,
  },
];

export const reviews: Review[] = [
  {
    heading: "I'm hooked!",
    review:
      "Just wow! By far this is the freshest music I have encountered... I'm hooked!",
    name: 'QueenRez',
    rating: 5,
    flag: '🇺🇸',
  },

  {
    heading: 'Covers all the bases',
    review:
      'Uppbeat is affordable, the licensing procedures are clearly described, and best of all, the site is clearly organized with a great variety of music styles and sound effects.',
    name: 'Chuck',
    rating: 5,
    flag: '🇺🇸',
  },

  {
    heading: 'Customer service is exceptional',
    review:
      "Customer service is absolutely exceptional. They are on top of everything and always strive to make things work. I am very pleased with their website as well. I'm so glad I found them.",
    name: 'Graciela Dulce',
    rating: 5,
    flag: '🇨🇦',
  },
  {
    heading: 'Amazing customer service',
    review:
      'The customer service at Uppbeat are incredible. They always want to help and will keep you up to date and respond very quickly. Jennah M is an absolute angel and I am very happy with the service thus far.',
    name: 'Cheerful Darkside',
    rating: 5,
    flag: '🇨🇦',
  },
  {
    heading: 'Upgraded to Premium!',
    review:
      'Decided to upgrade to Premium for a small fee, finally! Why? Because the people at uppbeat proved to be so lovely and nice while helping me with my basic membership. ',
    name: "Yummy K's",
    rating: 5,
    flag: '🇨🇦',
  },
  {
    heading: 'Great resource for video creators!',
    review:
      'If you are looking for quality and affordable music and sound effects Uppbeat is your choice. Its categorization makes really easy to find what you need. Very happy with them so far :)',
    name: 'Javier Cristóbal',
    rating: 5,
    flag: '🇪🇸',
  },
  {
    heading: 'Uppbeat is an amazing tool for content…',
    review:
      'Uppbeat is an amazing tool for content creators to use and enhance their videos for a better viewing experience.',
    name: 'Axuriff',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Great Selection, Easy Navigation, Awesome!',
    review:
      'I am so glad I became a member of Uppbeat. Thank you Uppbeat for making the music selection process so simple. One less thing to make my life less stressful!',
    name: 'GoldOwlGaming',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'Great music and sound effects',
    review:
      'Great music and sound effects! Added life to my project! Thank you to all the artist and Uppbeat!',
    name: 'Thaynito',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'LOVE UPPBEAT!',
    review:
      'Such a great platform and a wide selection of music! Nothing better than supporting talented small artists while providing a way to make more moving videos with their music!',
    name: 'Jared Bender',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'This is the greatest music platform',
    review:
      'This is the greatest music platform. Wow, Amazing, unbelievable, I love Uppbeat 😊',
    name: 'Kaushal Yadav',
    rating: 5,
    flag: '🇮🇳',
  },
  {
    heading: 'A perfect diverse library',
    review:
      "Fab website with a perfect diverse library of music both free and paid. Can't recommend enough.",
    name: 'Craig Woodhams',
    rating: 5,
    flag: '🇬🇧',
  },

  {
    heading: '12/10',
    review:
      'Its got a ton of songs and a ton of sound effects for super cheap and a lot of them are crazy good so if you are just starting youtube or something this is a great thing to have.',
    name: 'GOTTEM',
    rating: 5,
    flag: '🇺🇸',
  },
  {
    heading: 'The music and customer support are perfect!!',
    review:
      'The music is great, and the customer support responded quickly and helped me perfectly. The whole experience with Uppbeat is great!!',
    name: 'Ikko Nishimura',
    rating: 5,
    flag: '🇯🇵',
  },
  ...reviewRowOne,
  ...reviewRowTwo,
];

export const pairReviews = () => {
  const result: Review[][] = [];
  let currentPair: Review[] = [];

  let { length } = reviewRowOne;

  if (reviewRowTwo.length < reviewRowOne.length) {
    length = reviewRowTwo.length;
  }

  let index = 0;

  while (index < length) {
    currentPair.push(reviewRowOne[index]);
    currentPair.push(reviewRowTwo[index]);

    result.push(currentPair);
    currentPair = [];

    index += 1;
  }

  return result;
};
